import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "../Modules/Dashboard";
import PrivateRoutes from "./PrivateRoutes";
import Login from "../PublicModels/Login";
import PublicRoutes from "./PublicRoutes";
import Page404 from "../Common/Page404";
import Addadmin from "../Modules/Admin/Addadmin";
import UpdateAdmin from "../Modules/Admin/UpdateAdmin";
import UpdateCategory from "../Modules/Category/UpdateCategory";
import AddUser from "../Modules/User/AddUser";
import UpdateUser from "../Modules/User/UpdateUser";
import UserList from "../Modules/User/UserList";
import CategoryList from "../Modules/Category/CategoryList";
import AdminList from "../Modules/Admin/AdminList";
import SavedAddressList from "../Modules/User/SavedAddressList";
import AddMembership from "../Modules/Membership/AddMembership";
import UpdateMembership from "../Modules/Membership/UpdateMembership";
import InvoiceList from "../Modules/Invoice/InvoiceList";
import AddInvoice from "../Modules/Invoice/AddInvoice";
import UpdateInvoice from "../Modules/Invoice/UpdateInvoice";
import SettingsList from "../Modules/Settings/SettingsList";
import CustomerMemberShipList from "../Modules/CustomerMembership/CustomerMemberShipList";
import AddCustomermembership from "../Modules/CustomerMembership/AddCustomermembership";
import Customer360List from "../Modules/CustomerMembership/Customer360List";
import UserJourneyTracking from "../Modules/UserJourney/UserJourneyTracking";
import ReportsList from "../Modules/Reports/ReportsList";
import AddCategories from "../Modules/Categories/AddCategories";
import CategoriesList from "../Modules/Categories/CategoriesList";
import UpdateCategories from "../Modules/Categories/UpdateCategories";
import ServiceList from "../Modules/Service/ServiceList";
import AddService from "../Modules/Service/AddService";
import UpdateService from "../Modules/Service/UpdateService";
import CmsData from "../Modules/Cms/CmsData";
import LegalDocuments from '../Modules/Cms/LegalDocuments';
import Section2Add from "../Modules/Cms/Section2Add";
import Section3List from "../Modules/Cms/Section3List";
import Section3Add from "../Modules/Cms/Section3Add";
import Section3Update from "../Modules/Cms/Section3Update";
import Section4List from "../Modules/Cms/Section4List";
import Section4Add from "../Modules/Cms/Section4Add";
import Section4Update from "../Modules/Cms/Section4Update";
import Section5Update from "../Modules/Cms/Section5Update";
import Section5Add from "../Modules/Cms/Section5Add";
import Section5List from "../Modules/Cms/Section5List";
import Section6List from "../Modules/Cms/Section6List";
import Section6Update from "../Modules/Cms/Section6Update";
import Section6Add from "../Modules/Cms/Section6Add";
import SectionWhyChooseListing from "../Modules/Cms/SectionWhyChooseListing";
import SectionWhyChooseAdd from "../Modules/Cms/SectionWhyChooseAdd";
import SectionWhyChooseUpdate from "../Modules/Cms/SectionWhyChooseUpdate";
import Sectionfaqlist from "../Modules/Cms/Sectionfaqlist";
import SectionfaqAdd from "../Modules/Cms/SectionfaqAdd";
import SectionfaqUpdate from "../Modules/Cms/SectionfaqUpdate";
import AddOnList from "../Modules/AddOns/AddOnList";
import MemberShipList from "../Modules/Membership/MemberShipList";
import CreateTopUp from "../Modules/AddOns/CreateTopUp";
import UpdateTopUp from "../Modules/AddOns/UpdateTopUp";
import MemberReports from "../Modules/Reports/CustomerReport";
import FreeTrailReport from "../Modules/Reports/FreeTrailReport";
import InvoiceReport from "../Modules/Reports/InvoiceReport";
import MemberShipData from "../Modules/Settings/MemberShipData";
import CustomerReport from "../Modules/Reports/CustomerReport";
import MemberShipReport from "../Modules/Reports/MemberShipReport";
import TopUpReport from "../Modules/Reports/AddOnReports";
import TransactionReport from "../Modules/Reports/TransactionReport";
import PaymentLogsReport from "../Modules/Reports/PaymentLogsReport";
import PaymentsReport from "../Modules/Reports/PaymentsReport";
import AddReferral from "../Modules/User/AddReferral";
import Addreferal from "../Modules/Referals/Addreferal";
import ReferalList from "../Modules/Referals/ReferalList";
import UpdateReferalUser from "../Modules/Referals/UpdateReferalUser";
import Ticketslist from "../Modules/Tickets/Ticketslist";
import CreateTicket from "../Modules/Tickets/CreateTicket";
import UpdateTicket from "../Modules/Tickets/UpdateTicket";
import UserTicketsList from "../Modules/UserTickets/UserTicketsList";
import UserTicketUpdate from "../Modules/UserTickets/UserTicketUpdate";
import Enquires from "../Modules/Enquiries/Enquires";
import UpdateEnquiry from "../Modules/Enquiries/UpdateEnquiry";
import AddCreditNote from "../Modules/Invoice/AddCreditNote";
import ViewNoteDetails from "../Modules/Invoice/ViewNoteDetails";
import AddDebitNotes from "../Modules/Invoice/AddDebitNotes";
import SeoHome from "../Modules/SEO/SeoHome";
import Seopricing from "../Modules/SEO/Seopricing";
import SeoFaq from "../Modules/SEO/SeoFaq";
import AddCreditNotes from "../Modules/SfInvoice/AddCreditNotes";
import AddDebitNotess from "../Modules/SfInvoice/AddDebitNotess";
import AddInvoices from "../Modules/SfInvoice/AddInvoices";
import CreditNotesLists from "../Modules/SfInvoice/CreditNotesLists";
import DebitNotesLists from "../Modules/SfInvoice/DebitNotesLists";
import InvoiceLists from "../Modules/SfInvoice/InvoiceLists";
import UpdateInvoices from "../Modules/SfInvoice/UpdateInvoices";
import ViewNoteDetailss from "../Modules/SfInvoice/ViewNoteDetailss";
import VatReport from "../Modules/SfInvoice/VatReport";
import SeoTopManager from "../Modules/SEO/SeoTopManager";
import WebHookUrl from "../Modules/Settings/WebHookUrl";
import MemberShipReports from "../Modules/Reports/MemberShipReports";
import ZatcaDowntimeHold from "../Modules/Settings/ZatcaDowntimeHold";
import InvoiceEmailSenders from "../Modules/Settings/InvoiceEmailSenders";
import OutgoingInvoiceEmails from "../Modules/Settings/OutgoingInvoiceEmails";
import ShopifyMembershipMonitor from "../Modules/Settings/ShopifyMembershipMonitor";

function AppRoutes() {
  return (
    <div className="app">
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoutes>
              <Login />
            </PublicRoutes>
          }
        />

        <Route
          path="/dashboard"
          element={
            <PrivateRoutes>
              <Dashboard />
            </PrivateRoutes>
          }
        />
        <Route
          path="/category"
          element={
            <PrivateRoutes>
              <CategoryList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/category/add"
          element={
            <PrivateRoutes>
              <AddCategories />
            </PrivateRoutes>
          }
        />
        <Route
          path="/user/update/:id"
          element={
            <PrivateRoutes>
              <SavedAddressList />
            </PrivateRoutes>
          }
        />

        <Route
          path="/category/update/:id"
          element={
            <PrivateRoutes>
              <UpdateCategory />
            </PrivateRoutes>
          }
        />

        <Route
          path="/admin"
          element={
            <PrivateRoutes>
              <AdminList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/admin/add"
          element={
            <PrivateRoutes>
              <Addadmin />
            </PrivateRoutes>
          }
        />
        <Route
          path="/admin/update/:id"
          element={
            <PrivateRoutes>
              <UpdateAdmin />
            </PrivateRoutes>
          }
        />

        <Route
          path="/user"
          element={
            <PrivateRoutes>
              <UserList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/user/add"
          element={
            <PrivateRoutes>
              <AddUser />
            </PrivateRoutes>
          }
        />
        <Route
          path="/user/update/:id"
          element={
            <PrivateRoutes>
              <UpdateUser />
            </PrivateRoutes>
          }
        />

        <Route
          path="/membership"
          element={
            <PrivateRoutes>
              <MemberShipList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addmembership"
          element={
            <PrivateRoutes>
              <AddMembership />
            </PrivateRoutes>
          }
        />
        <Route
          path="/updatemembership/:id"
          element={
            <PrivateRoutes>
              <UpdateMembership />
            </PrivateRoutes>
          }
        />
        <Route
          path="/topuplist"
          element={
            <PrivateRoutes>
              <AddOnList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/trialslist"
          element={
            <PrivateRoutes>
              <MemberShipData />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addtopup"
          element={
            <PrivateRoutes>
              <CreateTopUp />
            </PrivateRoutes>
          }
        />
        <Route
          path="/updatetopup/:id"
          element={
            <PrivateRoutes>
              <UpdateTopUp />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addreferal"
          element={
            <PrivateRoutes>
              <Addreferal />
            </PrivateRoutes>
          }
        />
        <Route
          path="/referallist"
          element={
            <PrivateRoutes>
              <ReferalList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/referallist/updateuser/:uid"
          element={
            <PrivateRoutes>
              <UpdateReferalUser />
            </PrivateRoutes>
          }
        />

        <Route
          path="/invoice"
          element={
            <PrivateRoutes>
              <InvoiceList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/invoices"
          element={
            <PrivateRoutes>
              <InvoiceLists />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addinvoice"
          element={
            <PrivateRoutes>
              <AddInvoice />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addinvoices"
          element={
            <PrivateRoutes>
              <AddInvoices />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addcreditnotes"
          element={
            <PrivateRoutes>
              <AddCreditNote />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addcreditnotess"
          element={
            <PrivateRoutes>
              <AddCreditNotes />
            </PrivateRoutes>
          }
        />
        <Route
          path="/adddebitnotes"
          element={
            <PrivateRoutes>
              <AddDebitNotes />
            </PrivateRoutes>
          }
        />
        <Route
          path="/settings_webhook_url"
          element={
            <PrivateRoutes>
              <WebHookUrl />
            </PrivateRoutes>
          }
        />
        <Route
          path="/zatca-downtime"
          element={
            <PrivateRoutes>
              <ZatcaDowntimeHold />
            </PrivateRoutes>
          }
        />
        <Route path="/invoice-email-senders" element={<PrivateRoutes><InvoiceEmailSenders /></PrivateRoutes>} />
        <Route path="/outgoing-invoice-emails" element={<PrivateRoutes><OutgoingInvoiceEmails /></PrivateRoutes>} />
        <Route
          path="/shopify-membership-monitor"
          element={
            <PrivateRoutes>
              <ShopifyMembershipMonitor />
            </PrivateRoutes>
          }
        />

        <Route
          path="/tap_manager"
          element={
            <PrivateRoutes>
              <SeoTopManager />
            </PrivateRoutes>
          }
        />
        <Route
          path="/adddebitnotess"
          element={
            <PrivateRoutes>
              <AddDebitNotess />
            </PrivateRoutes>
          }
        />
        <Route
          path="/creditnoteslist"
          element={
            <PrivateRoutes>
              <Navigate to="/invoice?invoice_type=3" replace />
            </PrivateRoutes>
          }
        />
        <Route
          path="/membership_invoice"
          element={
            <PrivateRoutes>
              <MemberShipReports />
            </PrivateRoutes>
          }
        />
        <Route
          path="/creditnoteslists"
          element={
            <PrivateRoutes>
              <CreditNotesLists />
            </PrivateRoutes>
          }
        />
        <Route
          path="/debitnoteslist"
          element={
            <PrivateRoutes>
              <Navigate to="/invoice?invoice_type=4" replace />
            </PrivateRoutes>
          }
        />
        <Route
          path="/debitnoteslists"
          element={
            <PrivateRoutes>
              <DebitNotesLists />
            </PrivateRoutes>
          }
        />
        <Route
          path="/vatreport"
          element={
            <PrivateRoutes>
              <VatReport />
            </PrivateRoutes>
          }
        />
        <Route
          path="/viewnote/:id/:type"
          element={
            <PrivateRoutes>
              <ViewNoteDetails />
            </PrivateRoutes>
          }
        />
        <Route
          path="/viewnotes/:id/:type"
          element={
            <PrivateRoutes>
              <ViewNoteDetailss />
            </PrivateRoutes>
          }
        />
        <Route
          path="/updateinvoice/:id"
          element={
            <PrivateRoutes>
              <UpdateInvoice />
            </PrivateRoutes>
          }
        />
        <Route
          path="/updateinvoices/:id"
          element={
            <PrivateRoutes>
              <UpdateInvoices />
            </PrivateRoutes>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoutes>
              <SettingsList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/customermembership"
          element={
            <PrivateRoutes>
              <CustomerMemberShipList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/customer360"
          element={
            <PrivateRoutes>
              <Customer360List />
            </PrivateRoutes>
          }
        />
        <Route
          path="/user-journey"
          element={
            <PrivateRoutes>
              <UserJourneyTracking />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addcustomermembership"
          element={
            <PrivateRoutes>
              <AddCustomermembership />
            </PrivateRoutes>
          }
        />
        <Route
          path="/reports"
          element={
            <PrivateRoutes>
              <ReportsList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/invoicereports"
          element={
            <PrivateRoutes>
              <InvoiceReport />
            </PrivateRoutes>
          }
        />
        <Route
          path="/customerreport"
          element={
            <PrivateRoutes>
              <CustomerReport />
            </PrivateRoutes>
          }
        />
        <Route
          path="/membershipreport"
          element={
            <PrivateRoutes>
              <MemberShipReport />
            </PrivateRoutes>
          }
        />
        <Route
          path="/topupreports"
          element={
            <PrivateRoutes>
              <TopUpReport />
            </PrivateRoutes>
          }
        />
        <Route
          path="/freetrailreports"
          element={
            <PrivateRoutes>
              <FreeTrailReport />
            </PrivateRoutes>
          }
        />
        <Route
          path="/transactionreport"
          element={
            <PrivateRoutes>
              <TransactionReport />
            </PrivateRoutes>
          }
        />
        <Route
          path="/paymentlogsreport"
          element={
            <PrivateRoutes>
              <PaymentLogsReport />
            </PrivateRoutes>
          }
        />
        <Route
          path="/paymentsreport"
          element={
            <PrivateRoutes>
              <PaymentsReport />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addcategories"
          element={
            <PrivateRoutes>
              <AddCategories />
            </PrivateRoutes>
          }
        />
        <Route
          path="/categories"
          element={
            <PrivateRoutes>
              <CategoriesList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/udpatecategory/:id"
          element={
            <PrivateRoutes>
              <UpdateCategories />
            </PrivateRoutes>
          }
        />
        <Route
          path="/services"
          element={
            <PrivateRoutes>
              <ServiceList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addservices"
          element={
            <PrivateRoutes>
              <AddService />
            </PrivateRoutes>
          }
        />
        <Route
          path="/updateservices/:id"
          element={
            <PrivateRoutes>
              <UpdateService />
            </PrivateRoutes>
          }
        />

        <Route
          path="/cms/legal/:slug?"
          element={<PrivateRoutes><LegalDocuments /></PrivateRoutes>}
        />
        <Route
          path="/cms"
          element={
            <PrivateRoutes>
              <CmsData />
            </PrivateRoutes>
          }
        />

        <Route
          path="/section2"
          element={
            <PrivateRoutes>
              <Section2Add />
            </PrivateRoutes>
          }
        />
        <Route
          path="/section3"
          element={
            <PrivateRoutes>
              <Section3List />
            </PrivateRoutes>
          }
        />
        <Route
          path="/section3add"
          element={
            <PrivateRoutes>
              <Section3Add />
            </PrivateRoutes>
          }
        />
        <Route
          path="/updatesection3/:id"
          element={
            <PrivateRoutes>
              <Section3Update />
            </PrivateRoutes>
          }
        />

        <Route
          path="/section4"
          element={
            <PrivateRoutes>
              <Section4List />
            </PrivateRoutes>
          }
        />

        <Route
          path="/section4add"
          element={
            <PrivateRoutes>
              <Section4Add />
            </PrivateRoutes>
          }
        />
        <Route
          path="/section4update/:id"
          element={
            <PrivateRoutes>
              <Section4Update />
            </PrivateRoutes>
          }
        />
        <Route
          path="/section5update/:id"
          element={
            <PrivateRoutes>
              <Section5Update />
            </PrivateRoutes>
          }
        />
        <Route
          path="/section5add"
          element={
            <PrivateRoutes>
              <Section5Add />
            </PrivateRoutes>
          }
        />
        <Route
          path="/section5"
          element={
            <PrivateRoutes>
              <Section5List />
            </PrivateRoutes>
          }
        />
        <Route
          path="/section6update/:id"
          element={
            <PrivateRoutes>
              <Section6Update />
            </PrivateRoutes>
          }
        />
        <Route
          path="/section6"
          element={
            <PrivateRoutes>
              <Section6List />
            </PrivateRoutes>
          }
        />
        <Route
          path="/section6add"
          element={
            <PrivateRoutes>
              <Section6Add />
            </PrivateRoutes>
          }
        />
        <Route
          path="/sectionwhychooose"
          element={
            <PrivateRoutes>
              <SectionWhyChooseListing />
            </PrivateRoutes>
          }
        />
        <Route
          path="/sectionwhychoooseadd"
          element={
            <PrivateRoutes>
              <SectionWhyChooseAdd />
            </PrivateRoutes>
          }
        />
        <Route
          path="/sectionwhychoooseupdate/:id"
          element={
            <PrivateRoutes>
              <SectionWhyChooseUpdate />
            </PrivateRoutes>
          }
        />

        <Route
          path="/sectionfaq"
          element={
            <PrivateRoutes>
              <Sectionfaqlist />
            </PrivateRoutes>
          }
        />

        <Route
          path="/sectionfaqadd"
          element={
            <PrivateRoutes>
              <SectionfaqAdd />
            </PrivateRoutes>
          }
        />

        <Route
          path="/sectionfaqupdate/:id"
          element={
            <PrivateRoutes>
              <SectionfaqUpdate />
            </PrivateRoutes>
          }
        />
        <Route
          path="/ticketslist"
          element={
            <PrivateRoutes>
              <Ticketslist />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addticket"
          element={
            <PrivateRoutes>
              <CreateTicket />
            </PrivateRoutes>
          }
        />
        <Route
          path="/updateticket/:tid"
          element={
            <PrivateRoutes>
              <UpdateTicket />
            </PrivateRoutes>
          }
        />
        <Route
          path="/userticketslist"
          element={
            <PrivateRoutes>
              <UserTicketsList />
            </PrivateRoutes>
          }
        />

        <Route
          path="/updateuserticket/:utid"
          element={
            <PrivateRoutes>
              <UserTicketUpdate />
            </PrivateRoutes>
          }
        />
        <Route
          path="/enqurieslist"
          element={
            <PrivateRoutes>
              <Enquires />
            </PrivateRoutes>
          }
        />

        <Route
          path="/seo"
          element={
            <PrivateRoutes>
              <SeoHome />
            </PrivateRoutes>
          }
        />
        <Route
          path="/pricing"
          element={
            <PrivateRoutes>
              <Seopricing />
            </PrivateRoutes>
          }
        />
        <Route
          path="/faq"
          element={
            <PrivateRoutes>
              <SeoFaq />
            </PrivateRoutes>
          }
        />

        <Route
          path="/updateenquiry/:eqid"
          element={
            <PrivateRoutes>
              <UpdateEnquiry />
            </PrivateRoutes>
          }
        />

        <Route
          path="*"
          element={
            <PrivateRoutes>
              <Page404 />
            </PrivateRoutes>
          }
        />
      </Routes>
    </div>
  );
}

export default AppRoutes;
